import { render, staticRenderFns } from "./TableCalculoAdministrativo.vue?vue&type=template&id=ae4b7e96&scoped=true"
import script from "./TableCalculoAdministrativo.vue?vue&type=script&lang=js"
export * from "./TableCalculoAdministrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4b7e96",
  null
  
)

export default component.exports